import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type {
  CentralMappingCategory,
  CentralMappingMarketSubscription,
} from 'lumen/models';
import type { PmsValueType } from 'lumen/utils/central-mapping-constants';
import dirtyRelationship, {
  type DirtyRelationshipModel,
} from 'lumen/utils/decorators/dirty-relationship';

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
interface CentralMappingMappingEntry extends DirtyRelationshipModel, Model {}

@dirtyRelationship()
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class CentralMappingMappingEntry extends Model {
  [Type] = 'central-mapping/mapping-entry' as const;

  // The category chosen by backends auto-mapping algorithm. Can not be adjusted by the user.

  @belongsTo('central-mapping/category', { async: false, inverse: null })
  declare autoCategory: CentralMappingCategory | null;

  @belongsTo('central-mapping/market-subscription', {
    async: false,
    inverse: null,
  })
  declare subscription: CentralMappingMarketSubscription;

  // The category chosen by the user. Can be adjusted by the user.

  @belongsTo('central-mapping/category', { async: false, inverse: null })
  declare userCategory: CentralMappingCategory | null;

  @attr('string') declare description: string;
  @attr('string') declare descriptionByPms: string;
  @attr('string') declare value: string;
  @attr('string') declare valueType: PmsValueType;

  get brands(): string[] {
    return this.subscription.brands ?? [];
  }

  get category(): CentralMappingCategory | null {
    const { userCategory, autoCategory } = this;

    return userCategory ?? autoCategory;
  }

  get chains(): string[] {
    return this.subscription.chains ?? [];
  }

  get descriptionToDisplay(): string {
    return this.description || this.descriptionByPms;
  }

  get hotelName(): string {
    return this.subscription.displayName ?? null;
  }

  get isAutomapped(): boolean {
    return Boolean(!this.userCategory && this.autoCategory);
  }

  get isUnmapped(): boolean {
    return !this.category;
  }

  get isUnsaved(): boolean {
    return Boolean(this.hasDirtyAttributes) || this.hasDirtyRelationships;
  }
}

export default CentralMappingMappingEntry;
